import React from 'react';
import PropTypes from 'prop-types';
import Product from './Product';
import ProductII from '../ProductListII/Product';
import RichText from '../Prismic/RichText';
import ProductCardList from '../ProductCardList';
import Loading from '../Loading/Loading';

import './RelatedProducts.scss';

const RelatedProducts = props => {
  const isUsingProductCards = props.theme === 'product-cards';

  let ProductComponent = Product;
  let showDescription = false;
  let showPrice = false;

  if (isUsingProductCards) {
    ProductComponent = ProductII;
    showDescription = props.productCardSizeOption === 'large' || props.productCardSizeOption === 'medium-description';
    showPrice = props.productCardSizeOption === 'large' || props.productCardSizeOption === 'medium-price';
  }

  return (
    <section className="related-products">
      <div className="container-guttered">
        <h3 className="text-giga">{props.title}</h3>
        {props.content &&
          <RichText
            fields={props.content}
            className="related-products-content"
          />
        }
        <div className="related-products-grid">
          {props.isLoading &&
            <Loading relative dark small />
          }
          {!props.isLoading &&
            <ProductCardList
              showArrow={props.showArrow}
              showDescription={showDescription}
              showPrice={showPrice}
              items={props.items}
              ageRangeLabel={props.ageRangeLabel}
              component={ProductComponent}
            />
          }
        </div>
      </div>
    </section>
  );
};


RelatedProducts.propTypes = {
  title: PropTypes.string,
  theme: PropTypes.string,
  ageRangeLabel: PropTypes.string,
  productCardSizeOption: PropTypes.string,
  showBadge: PropTypes.string,
  showArrow: PropTypes.bool,
  isLoading: PropTypes.bool,
  content: PropTypes.array,
  items: PropTypes.array,
};

export default RelatedProducts;



// WEBPACK FOOTER //
// ./src/client/js/view/components/RelatedProducts/RelatedProducts.js